import React from "react";

interface StraightArrowIconProps {
    rotate?: number;
}

export default function StraightArrowIcon(props: StraightArrowIconProps) {
    return <svg style={props.rotate ? {
        transform: "rotate(" + props.rotate + "deg)"
    } : {}} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"/></svg>;
}